export const AuthorizationUserType = {
  Staff: 'staff',
  User: 'user',
} as const
export type AuthorizationUserType = (typeof AuthorizationUserType)[keyof typeof AuthorizationUserType]
